/** Return true if the two objects are equal (note this is single depth) */
export const isObjectsEqual = (
  lhs: { [k: string]: string | number | boolean | null | undefined },
  rhs: { [k: string]: string | number | boolean | null | undefined }
): boolean => {
  const lk = Object.keys(lhs);
  const rk = Object.keys(rhs);
  // check that there are the same exact keys
  if (lk.length !== rk.length) {
    return false;
  }

  // check if there are any non-equal keys
  return lk.filter((kk) => lhs[kk] !== rhs[kk]).length === 0;
};
